window.addEventListener('DOMContentLoaded', () => {
  $('.btn-nav__link').on('click', function(){
    let index = $('.btn-nav__link').index(this);

    $('.btn-nav__link').removeClass('current_nav');
    $('.btn-nav__link').eq(index).addClass('current_nav');
    $('.nav-contents').removeClass('current-content');
    $('.nav-contents').eq(index).addClass('current-content');
  });
});
